import React, { useEffect, useState } from "react";
import FlashcardApp from "./FlashcardApp";
import TopicSelection from "./TopicSelection";
import "./App.css";
import logo from "./logo.png";
import { supabase } from "./supabase";


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginUsername, setLoginUsername] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [role, setRole] = useState("user");
  const [user, setUser] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [loading, setLoading] = useState(false);

  const [users, setUsers] = useState([]);
  
const [userPage, setUserPage] = useState(1);

const USERS_PER_PAGE = 5;

const totalUserPages = Math.ceil(
  users.length / USERS_PER_PAGE
);

const startIndex =
  (userPage - 1) * USERS_PER_PAGE;

const currentUsers =
  users.slice(
    startIndex,
    startIndex + USERS_PER_PAGE
  );
 useEffect(() => {
  const checkUser = async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session?.user) return;

    setUser(session.user);
    setIsLoggedIn(true);

    const { data: profile } = await supabase
      .from("profiles")
      .select("role")
      .eq("id", session.user.id)
      .single();

    const admin = profile?.role === "admin";
    setIsAdmin(admin);

    if (admin) {
      await fetchUsers();
    }
  };

  checkUser();
}, []);

  // ================= USERS =================
const fetchUsers = async () => {
  console.log("fetchUsers called");

  const { data, error } = await supabase
    .from("profiles")
    .select("*")
    .order("email");

  console.log("DATA:", data);
  console.log("ERROR:", error);

  setUsers(data || []);
};

const addUser = async () => {
  try {
    // Username ને email માં convert કરો
    const email = `${newUsername.toLowerCase()}@test.com`;

    const response = await fetch(
      "https://fxqagvcgdrfnzmhxgcrt.supabase.co/functions/v1/create-user",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password: newPassword,
          role,
        }),
      }
    );

    const text = await response.text();

    console.log("FUNCTION RESPONSE:", text);

    const result = JSON.parse(text);

    if (!response.ok) {
      alert(result.error || "Failed to create user");
      return;
    }

    alert("User Added Successfully ✅");

    setNewUsername("");
    setNewPassword("");

    fetchUsers();
  } catch (err) {
    console.error("CREATE USER ERROR:", err);
    alert(err.message || "Error creating user");
  }
};

const deleteUser = async (id) => {
  try {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );

    if (!confirmDelete) return;

    const response = await fetch(
      "https://fxqagvcgdrfnzmhxgcrt.supabase.co/functions/v1/delete-user",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: id,
        }),
      }
    );

    const result = await response.json();

    console.log("DELETE RESPONSE:", result);

    if (!response.ok) {
      console.error(result);
      alert(JSON.stringify(result));
      return;
    }

    alert("User deleted successfully ✅");
    fetchUsers();
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

  // ================= LOGIN =================
const handleLogin = async () => {
  setLoading(true);

  // જો email લખે તો email વાપરો, નહીં તો username ને @test.com માં convert કરો
  const email = loginUsername.includes("@")
    ? loginUsername
    : `${loginUsername.toLowerCase()}@test.com`;

  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password: loginPassword,
  });

  if (error) {
    alert(error.message);
    setLoading(false);
    return;
  }

  const { data: profile, error: profileError } = await supabase
    .from("profiles")
    .select("role")
    .eq("id", data.user.id)
    .single();

  if (profileError || !profile) {
    alert("Profile not found");
    setLoading(false);
    return;
  }

  setIsAdmin(profile.role === "admin");
  setUser(data.user);
  setIsLoggedIn(true);
  setLoading(false);
};

// ================= LOGOUT =================
const handleLogout = async () => {
  await supabase.auth.signOut();

  setIsLoggedIn(false);
  setIsAdmin(false);
  setUser(null);
  setSelectedTopic(null);
};

  return (
    <div>
      {!isLoggedIn ? (
        <div style={styles.loginContainer}>
          <div style={styles.loginCard}>
            <img src={logo} alt="logo" style={styles.logo} />
            <h2 style={styles.loginTitle}>Welcome Back 👋</h2>

            <input
              style={styles.input}
              placeholder="Username"
              value={loginUsername}
              onChange={(e) => setLoginUsername(e.target.value)}
            />

            <input
              style={styles.input}
              type="password"
              placeholder="Password"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
            />

          <button
  style={styles.loginButton}
  onClick={handleLogin}
  disabled={loading}
>
  {loading ? (
    <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <span className="spinner"></span>
      Logging in...
    </span>
  ) : (
    "Login 🚀"
  )}
</button>
          </div>
        </div>
      ) : (

        <div style={styles.mainContainer}>

  <div style={{ textAlign: "right", marginBottom: "20px" }}>
    <button
  style={styles.logoutButton}
  onClick={handleLogout}
>
  Logout
</button>
  </div>
          
          {isAdmin && (
  <div style={styles.header}>
    <img src={logo} alt="logo" style={styles.topLogo} />
    <h1 style={styles.mainTitle}>Admin Panel</h1>
  </div>
)}

          {/* ===== TOP CARDS (SIDE BY SIDE) ===== */}
          <div style={styles.topSection}>

            {/* ADD USER */}
            {isAdmin && (
              <div style={styles.card}>
                <h3 style={styles.cardTitle}>Add User</h3>

                <input
                  style={styles.input}
                  placeholder="Username"
                  value={newUsername}
                  onChange={(e) => setNewUsername(e.target.value)}
                />

                <input
                  style={styles.input}
                  placeholder="Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />

                <select
                  style={styles.select}
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>

                <button style={styles.addButton} onClick={addUser}>
                  + Add User
                </button>
              </div>
            )}

            {/* USERS LIST */}
            {isAdmin && (
              <div style={styles.card}>
                <h3 style={styles.cardTitle}>All Users</h3>

                {currentUsers.map((u) => (
                  <div key={u.id} style={styles.userItem}>
                    {u.email.split("@")[0]} ({u.role})
                    <button
                      style={styles.deleteBtn}
                      onClick={() => deleteUser(u.id)}
                    >
                      Delete
                    </button>
                  </div>
                ))}
                <div style={{ textAlign: "center", marginTop: "15px" }}>
  <button
    onClick={() => setUserPage(userPage - 1)}
    disabled={userPage === 1}
    style={styles.pageBtn}
  >
    Prev
  </button>

  <span
    style={{
      color: "white",
      margin: "0 10px",
      fontWeight: "bold",
    }}
  >
    {userPage} / {totalUserPages}
  </span>

  <button
    onClick={() => setUserPage(userPage + 1)}
    disabled={userPage === totalUserPages}
    style={styles.pageBtn}
  >
    Next
  </button>
</div>
              </div>
            )}
          </div>

          {/* ===== FLASHCARDS SECTION ===== */}
          <div style={styles.flashcardSection}>
{!selectedTopic ? (
  <TopicSelection
    onSelectTopic={setSelectedTopic}
  />
) : (
 <FlashcardApp
  isAdmin={isAdmin}
  user={user}
  topic={selectedTopic}
  onBack={() => setSelectedTopic(null)}
/>
)}</div>

        </div>
      )}
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  mainContainer: {
    background: "#38499D",
    minHeight: "100vh",
    padding: "30px 20px",
  },

  header: {
    textAlign: "center",
    marginBottom: "30px",
  },

  topLogo: {
    width: "500px",
    marginBottom: "10px",
  },

  mainTitle: {
    color: "white",
    fontSize: "28px",
  },

  topSection: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap",
    marginBottom: "40px",
  },

  card: {
    background: "rgba(255,255,255,0.15)",
    padding: "25px",
    borderRadius: "15px",
    backdropFilter: "blur(10px)",
    width: "320px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  cardTitle: {
    color: "white",
    textAlign: "center",
  },

  input: {
    padding: "10px",
    borderRadius: "8px",
    border: "none",
  },

  select: {
    padding: "10px",
    borderRadius: "8px",
    border: "none",
  },

  addButton: {
    padding: "10px",
    borderRadius: "8px",
    border: "none",
    background: "#00c2ff",
    color: "black",
    cursor: "pointer",
    fontWeight: "bold",
  },

  userItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "rgba(255,255,255,0.1)",
    padding: "8px",
    borderRadius: "8px",
    marginBottom: "8px",
    color: "white",
  },

  deleteBtn: {
    background: "#ff3b3b",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  flashcardSection: {
    marginTop: "20px",
  },

  /* LOGIN */
  loginContainer: {
    height: "100vh",
    background: "#38499D",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  loginCard: {
    background: "rgba(255,255,255,0.15)",
    padding: "40px",
    borderRadius: "15px",
    backdropFilter: "blur(10px)",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "300px",
    textAlign: "center",
  },

  loginTitle: {
    color: "white",
  },

  loginButton: {
    padding: "10px",
    borderRadius: "8px",
    border: "none",
    background: "black",
    color: "white",
    cursor: "pointer",
  },

logo: {
  width: "100%",
  maxWidth: "220px",
  height: "auto",
  display: "block",
  margin: "0 auto 15px",
  objectFit: "contain",
},

logoutButton: {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "none",
  background: "#ff3b3b",
  color: "white",
  cursor: "pointer",
  fontWeight: "bold",
},

pageBtn: {
  padding: "6px 12px",
  border: "none",
  borderRadius: "6px",
  background: "#00c2ff",
  color: "#000",
  cursor: "pointer",
  fontWeight: "bold",
},





};

export default App;